import MenuView from './MenuView';
import { connect } from 'react-redux';
import { Modals } from '../../../../core/constants';
import { AppState } from '../../../../state/createStore';
import { getDisplayableMenuSelector } from '../../../../state/selectors/menuViewSelector';
import { openModal, closeModal } from '../../../../state/session/session.actions';
import { bindActionCreators, Dispatch } from 'redux';
import { businessNotificationSelector } from '../../../../state/selectors/businessNotificationSelector';
import { clickOnMenuItem } from '../../../../state/cart/cart.actions';
import { selectLocationsWithNotification } from '../../../../state/selectors/locationsSelector';
import { BusinessNotifications } from '@wix/restaurants-client-logic';

function mapStateToProps(state: AppState) {
  const businessNotification = businessNotificationSelector(state);

  const isRestaurantTakingOrders =
    businessNotification?.notification !== BusinessNotifications.RestaurantClosed &&
    businessNotification?.notification !== BusinessNotifications.OlOunavailable;

  return {
    displayableMenu: getDisplayableMenuSelector(state),
    orderItemsCount: state.cart.orderItems.length,
    isMobile: state.platformParams.isMobile,
    siteIsTemplate: state.platformParams?.instance?.siteIsTemplate,
    layout: state.platformParams.settings.layout,
    dishCardAlignment: state.platformParams.settings.dishCardAlignment,
    menuHeaderAlignment: state.platformParams.settings.menuHeaderAlignment,
    menuDisplayOptions: {
      hideDishImages: !state.platformParams.settings.showDishImages,
      hideSectionImages: !state.platformParams.settings.showSectionImages,
      hideDishDescriptions: !state.platformParams.settings.showDescriptions,
      hideMenuItemLabels: !state.platformParams.settings.showLabels,
      hideMenuDescription: !state.platformParams.settings.showMenuDescription,
      hideSectionDescription: !state.platformParams.settings.showSectionDescription,
    },
    isRTL: state.platformParams.isRTL,
    isCartModalOpen: !!state.session.modals.find(({ modal }) => modal === Modals.CART_MODAL),
    notification: businessNotification?.notification,
    restaurant: state.session.restaurant,
    locations: selectLocationsWithNotification(state),
    isLocationPicked: state.session.isLocationPicked,
    selectAddressOnDishClick:
      state.session.isMultiLocation &&
      (!state.session.isLocationPicked ||
        (state.checkout.dispatch.type === 'delivery' && !state.checkout.dispatch.address.formatted)),
    isRestaurantTakingOrders,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      openModal,
      closeModal,
      clickOnMenuItem,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuView);
